import { render, staticRenderFns } from "./ProductsFeeds.vue?vue&type=template&id=289bc1c6"
import script from "./ProductsFeeds.vue?vue&type=script&lang=js"
export * from "./ProductsFeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289bc1c6')) {
      api.createRecord('289bc1c6', component.options)
    } else {
      api.reload('289bc1c6', component.options)
    }
    module.hot.accept("./ProductsFeeds.vue?vue&type=template&id=289bc1c6", function () {
      api.rerender('289bc1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Products/ProductsFeeds.vue"
export default component.exports